import type { DirectusImage } from './directusImage.model'
import { z } from 'zod'

export const directusImageDtoSchema = z.object({
  id: z.string(),
  storage: z.string(),
  filename_disk: z.string(),
  filename_download: z.string(),
  title: z.string(),
  type: z.string(),
  uploaded_on: z.string(),
  modified_on: z.string(),
  filesize: z.string(),
  width: z.number(),
  height: z.number(),
})

export type DirectusImageDto = z.infer<typeof directusImageDtoSchema>

export function transformDirectusImageDtoToDirectusImage(
  directusImageDto: DirectusImageDto,
): DirectusImage {
  return {
    id: directusImageDto.id,
    storage: directusImageDto.storage,
    filenameDisk: directusImageDto.filename_disk,
    filenameDownload: directusImageDto.filename_download,
    title: directusImageDto.title,
    type: directusImageDto.type,
    uploadedOn: directusImageDto.uploaded_on,
    modifiedOn: directusImageDto.modified_on,
    filesize: directusImageDto.filesize,
    width: directusImageDto.width,
    height: directusImageDto.height,
  }
}
